import { h, createContext } from "preact";
import { useState, useEffect, useRef } from "preact/hooks";
import CountdownForm from './CountdownForm'; // Убедитесь, что путь к файлу правильный

const InactivityTracker = ({ inactivityTime, countdownTime }) => {
  const [isInactive, setIsInactive] = useState(false);
  const inactivityTimeout = useRef(null);

  const resetTimer = () => {
    clearTimeout(inactivityTimeout.current);
    inactivityTimeout.current = setTimeout(() => {
      setIsInactive(true);
    }, inactivityTime);
  };

  useEffect(() => {
    // Добавляем обработчики событий для отслеживания активности
    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keypress', resetTimer);
    window.addEventListener('touchstart', resetTimer);

    // Запуск тай
    resetTimer();

    // Очищаем таймаут при размонтировании компонента
    return () => {
      clearTimeout(inactivityTimeout.current);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keypress', resetTimer);
      window.removeEventListener('touchstart', resetTimer);
    };
  }, []);

  return (
    <div>
      {isInactive && (
        <CountdownForm
          onClose={() => {
            setIsInactive(false);
            resetTimer(); // Сброс таймера после закрытия формы
          }}
          countdownTime={countdownTime}
        />
      )}
    </div>
  );
};

export default InactivityTracker;
